/* eslint-disable dot-notation */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable func-names */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { any } from 'prop-types';
import { withRouter } from 'react-router-dom';

import {
    getPickleBallRating,
    getRatingDetails,
    setRatingChoice,
} from '../../../utils';
import Description from '../../text/Description';
import BackgroundImage from '../../BackgroundImage';

import { divisionFormatTypeIds, sportTypeIds } from '../../../utils/eventConstants';
import { gameTypes } from '../../../utils/constants';

import styles from './playerSearch.scss';
import themeV3styles from '../themeV3.scss';

const EventPlayerSearch = (props) => {
    const { players, sportTypeId, user, handlePlayerSelect, divisionFormatTypeId, utrTypeId } = props;

    const [showDropdown, setShowDropdown] = useState(false);
    const [query, setQuery] = useState('');
    const [filteredOptions, setFilteredOptions] = useState(players);

    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (e) => {
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setShowDropdown(false);
        }
    };

    const handleOnFocus = (e) => {
        if (!showDropdown) {
            setShowDropdown(true);
        }
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleChange = (e) => {
        setQuery(e.target.value);
        if (e.target.value?.length) {
            const updatedPlayers = players.filter(player => {
                const playerName = `${player.firstName} ${player.lastName}`.toLowerCase();
                return playerName.includes(query.toLowerCase());
            });
            setFilteredOptions(updatedPlayers);
        } else {
            setFilteredOptions(players);
        }
    };

    const handleLinkClick = (player) => {
        const playerToSet = {
            ...player,
            displayName: `${player.firstName} ${player.lastName}`,
        };
        setQuery(playerToSet.displayName);
        setShowDropdown(false);
        handlePlayerSelect(playerToSet);
    };

    const closeDropdown = () => {
        setShowDropdown(false);
    };

    const clearQuery = () => {
        setQuery('');
        setFilteredOptions(players);
    };

    const renderPlayer = (player, i) => {
        const { firstName, lastName, gender, location, playerProfileImages, divisionName } = player;
        const userIsPowered = (user?.isPowered) || false;
        const ratingType = divisionFormatTypeId === divisionFormatTypeIds.SINGLES ? gameTypes.SINGLES : gameTypes.DOUBLES;
        const tennisRating = getRatingDetails(setRatingChoice({ player, ratingType, utrType: utrTypeId }), userIsPowered, false, false, false);
        const pickleballRating = getPickleBallRating(player, ratingType);
        let rating;
        if (sportTypeId === sportTypeIds.TENNIS) {
            rating = tennisRating?.value;
            if (tennisRating.showPBRRating) {
                rating = tennisRating.pbrRating?.ratingDisplay;
            }
        } else if (sportTypeId === sportTypeIds.PICKLEBALL) {
            rating = pickleballRating?.value;
        }
        const descriptionItems = [
            ...(gender ? [gender] : []),
            ...(rating ? [rating] : []),
            ...(location?.display ? [location.display] : []),
        ];
        return (
            <div className={`row ${styles.globalSearchDropdownOption}`} onClick={() => handleLinkClick(player)} key={`p${i}`}>
                <div className="col-2">
                    <div className="d-flex h-100 aic jcc" style={{ width: '32px' }}>
                        <BackgroundImage
                            baseUrl={'/v1/player/'}
                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                            images={playerProfileImages}
                            imageType={'thumbnail'}
                            extraCls={'playerThumbnailImage'}
                        />
                    </div>
                </div>
                <div className="col-10">
                    <div className={`${styles.name} show-ellipsis`}><span dangerouslySetInnerHTML={{ __html: `${firstName} ${lastName}` }} /> {rating.verified ? <i className="utr-icon icon-verified-blue d-inline-block" /> : ''}</div>
                    <div className={`${styles.place} show-ellipsis`}>
                        <Description desc={descriptionItems} />
                    </div>
                    {!!divisionName && (
                        <div className={`${styles.place} show-ellipsis`}>
                            {divisionName}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const renderDropdown = () => {
        return (
            <div className="pb24">
                {filteredOptions.length === 0 && (
                    <div className={styles.globalSearchDropdownNoMatches}>
                        No Matches Found
                    </div>
                )}
                {filteredOptions.length > 0 && (
                    <div className={styles.globalSearchDropdownOptions}>
                        {filteredOptions.map((player, i) => renderPlayer(player, i))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={`${styles.globalSearchContainer} ${styles.lookup} ${themeV3styles.themeV3}`} ref={wrapperRef}>
            <div className={`${styles.globalSearchInputContainer} ${showDropdown ? styles.showOnTop : ''} ${themeV3styles.inputWrapper}`}>
                {showDropdown && (
                    <span
                        className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                        onClick={closeDropdown}
                    />
                )}
                <input
                    type="text"
                    value={query}
                    className={`${styles.globalSearchInput} form-control ${props.className} ${showDropdown ? 'dropdown-open' : ''} ${themeV3styles.formControl}`}
                    onChange={handleChange}
                    onFocus={handleOnFocus}
                    placeholder={'Select a player'}
                />
                {query?.length > 0 ? (
                    <span
                        className={`form-control-feedback far fa-times ${styles.feedbackRight}`}
                        onClick={clearQuery}
                    />
                ) : (
                    <span
                        className={`form-control-feedback fas fa-caret-down ${styles.feedbackRight}`}
                        onClick={toggleDropdown}
                    />
                )}
            </div>
            {showDropdown && (
                <div className={`player-search-dropdown ${styles.globalSearchDropdownContainer}`}>
                    {renderDropdown()}
                </div>
            )}
        </div>
    );
};

EventPlayerSearch.propTypes = {
    players: PropTypes.arrayOf(any).isRequired,
    sportTypeId: PropTypes.number,
    user: PropTypes.objectOf(any).isRequired,
    handlePlayerSelect: PropTypes.func.isRequired,
    divisionFormatTypeId: PropTypes.number.isRequired,
    utrTypeId: PropTypes.number.isRequired,
};

EventPlayerSearch.defaultProps = {
    sportTypeId: sportTypeIds.TENNIS,
};

export default withRouter(EventPlayerSearch);
